import { render, staticRenderFns } from "./distributionMore.vue?vue&type=template&id=2320b600&scoped=true&"
import script from "./distributionMore.vue?vue&type=script&lang=js&"
export * from "./distributionMore.vue?vue&type=script&lang=js&"
import style0 from "./distributionMore.vue?vue&type=style&index=0&id=2320b600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2320b600",
  null
  
)

export default component.exports